
export default {
  name: 'H7ComparisonBanner',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
}
